import HomeNavBar from "@/components/HomeNavBar/HomeNavBar.vue";
import { get_token, get_user_details } from "@/router";
import Swal from "sweetalert2";

export default {
  components: {
    HomeNavBar
  },
  mounted() {
    this.token_exists = get_token();
    this.user_details = get_user_details();
    this.filter_membership_payment_history();
  },
  data() {
    return ({
      user: this.getUserData(),
      token_exists: false,
      user_details: {
        user_id: ''
      },
      payment_history_loading: true,
      membership_payment_history: [],
      membership_payment_history_id: null,
      current_membership: null,
      membership_name: '',
      membership_type: '',
      membership_price: 0,
      billing_cycle: '',
      renewal_date: null,
      cancel_at_period_end: false,
      is_active: false,
      userHasPaid: false,
      membership_card: null,
      membership_card_qr: "",
      membership_card_loading: false,
      membership_card_error: ""
    });
  },
  computed: {
    has_current_membership() {
      return Boolean(this.current_membership || this.membership_name);
    }
  },
  methods: {
    getUserData() {
      return ({
        user_id: ''
      });
    },
    getToken() {
      return get_token();
    },
    go_back() {
      this.$router.back();
    },
    open_membership_card() {
      this.membership_card_error = "";
      $("#membershipCardModal").modal("show");
      return this.get_membership_card();
    },
    close_membership_card() {
      $("#membershipCardModal").modal("hide");
    },
    get_membership_card() {
      if (this.membership_card_loading) return null;
      this.membership_card_loading = true;
      return $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/get_membership_card/`,
        method: "POST",
        data: JSON.stringify({ user_id: this.user.user_id }),
        xhrFields: { withCredentials: true },
        headers: {
          Authorization: `Token ${this.getToken()}`,
          "Content-Type": "application/json",
        },
        success: (response) => this.handle_membership_card_success(response),
        error: (xhr) => {
          this.membership_card_error = xhr.responseJSON?.message || "Unable to retrieve your membership card.";
        },
        complete: () => (this.membership_card_loading = false),
      });
    },
    handle_membership_card_success(response) {
      if (response?.status !== "success" || !response?.data) {
        this.membership_card_error = response?.message || "Unable to retrieve your membership card.";
        return;
      }
      this.membership_card = response.data;
      this.membership_card_qr = this.membership_card_qr_image(response.data.qr_code);
    },
    membership_card_qr_image(qr_code) {
      if (!qr_code) return "";
      return qr_code.startsWith("data:image") ? qr_code : `data:image/png;base64,${qr_code}`;
    },
    membership_card_name() {
      return this.membership_card?.membership?.name
        || this.membership_card?.membership?.membership_type?.name
        || "Membership";
    },
    membership_card_valid_thru() {
      const date = new Date(this.membership_card?.valid_until);
      if (Number.isNaN(date.getTime())) return "-- / --";
      return `${String(date.getMonth() + 1).padStart(2, "0")} / ${String(date.getFullYear()).slice(-2)}`;
    },
    format_currency(amount) {
      const value = Number(amount || 0);
      return `R ${value.toLocaleString('en-ZA', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}`;
    },
    format_display_date(date_value) {
      if (!date_value) {
        return '--';
      }

      const parsed_date = new Date(date_value);
      if (Number.isNaN(parsed_date.getTime())) {
        return '--';
      }

      return parsed_date.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric'
      });
    },
    get_payment_status(payment) {
      return String(payment?.payment_status?.status || '').toLowerCase();
    },
    resolve_current_membership(history = []) {
      const now = Date.now();
      const current_entry = history.find((payment) => {
        const validUntil = payment?.valid_until
          ? new Date(payment.valid_until).getTime()
          : Number.POSITIVE_INFINITY;
        return payment?.is_active
          && this.get_payment_status(payment) === 'paid'
          && validUntil > now;
      });
      return current_entry?.membership || null;
    },
    get_first_payment_history_entry(history = []) {
      return history[0] || null;
    },
    get_current_payment_history_entry(history = []) {
      const now = Date.now();
      return history.find((payment) => {
        const valid_until = payment?.valid_until
          ? new Date(payment.valid_until).getTime()
          : Number.POSITIVE_INFINITY;
        return payment?.is_active
          && this.get_payment_status(payment) === 'paid'
          && valid_until > now;
      }) || this.get_first_payment_history_entry(history);
    },
    set_membership_history_state(history = []) {
      this.membership_payment_history = history;
      this.current_membership = this.resolve_current_membership(history);
      this.userHasPaid = history.some(
        (payment) => payment?.is_active
          && this.get_payment_status(payment) === "paid"
          && (!payment?.valid_until || new Date(payment.valid_until).getTime() > Date.now())
      );
    },
    set_payment_history_entry_state(first_entry) {
      this.is_active = first_entry?.is_active || false;
      this.membership_payment_history_id = first_entry?.id || null;
      this.renewal_date = first_entry?.valid_until || null;
      this.cancel_at_period_end = first_entry?.cancel_at_period_end || false;
    },
    get_membership_detail_state(first_membership) {
      return ({
        membership_name: this.get_membership_name(first_membership),
        membership_type: this.get_membership_type(first_membership),
        billing_cycle: this.get_billing_cycle(first_membership),
        membership_price: this.get_membership_price(first_membership)
      });
    },

    get_membership_name(membership) {
      return membership?.name || '';
    },

    get_membership_type(membership) {
      return membership?.membership_type?.name || '';
    },

    get_billing_cycle(membership) {
      return membership?.billing_cycle?.name || '';
    },

    get_membership_price(membership) {
      return membership?.membership_pricing?.[0]?.price || 0;
},
    set_membership_detail_state(first_membership) {
      const membership_detail_state = this.get_membership_detail_state(first_membership);

      this.membership_name = membership_detail_state.membership_name;
      this.membership_type = membership_detail_state.membership_type;
      this.billing_cycle = membership_detail_state.billing_cycle;
      this.membership_price = membership_detail_state.membership_price;
    },
    apply_membership_payment_history(history = []) {
      const current_entry = this.get_current_payment_history_entry(history);
      const current_membership = current_entry?.membership || null;

      this.set_membership_history_state(history);
      this.set_payment_history_entry_state(current_entry);
      this.set_membership_detail_state(current_membership);
    },
    handle_membership_payment_history_success(response) {
      const history = response?.data?.payment_history || [];
      this.apply_membership_payment_history(history);
    },
    filter_membership_payment_history() {
      this.token_exists = get_token();

      if (!this.user.user_id) {
        this.user.user_id = this.$route.params.user_id || this.user_details.user_id;
      }

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/filter_user_membership_payment_history/`,
        method: "POST",
        data: JSON.stringify({ user_id: this.user.user_id }),
        headers: this.token_exists
          ? {
              Authorization: `Token ${this.getToken()}`,
              "Content-Type": "application/json",
            }
          : { "Content-Type": "application/json" },
        success: (response) => {
          this.handle_membership_payment_history_success(response);
        },
        complete: () => {
          this.payment_history_loading = false;
        },
      });
    },
    navigate_to_plans() {
    this.$router.push('/view_membership/');
    },
    cancel_membership() {
      const membershipEndDate = this.format_display_date(this.renewal_date);
      Swal.fire({
        title: 'Cancel membership?',
        text: `Your membership benefits will remain available until the end of your current membership period, ${membershipEndDate}.`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#6c757d',
        confirmButtonText: 'Yes, cancel membership',
        cancelButtonText: 'Keep membership'
      }).then((result) => {
        if (!result.isConfirmed) return;

        this.cancel_membership_loading = true;
        $.ajax({
          url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/cancel_membership/`,
          method: "POST",
          data: JSON.stringify({ membership_id: this.membership_payment_history_id }),
          headers: {
            Authorization: `Token ${this.getToken()}`,
            "Content-Type": "application/json",
          },
          success: (response) => {
            if (response.status === 'success') {
              this.handle_cancel_membership_success(response);
            }
          },
          complete: () => {
            this.cancel_membership_loading = false;
          },
        });
      });
    },
    handle_cancel_membership_success(response) {
      Swal.fire({
        icon: 'success',
        title: 'Cancellation scheduled',
        text: `Your membership remains active until ${this.format_display_date(response.valid_until)}.`,
        position: 'bottom-end',
        showConfirmButton: false,
        timer: 4000,
        toast: true
      });
      this.filter_membership_payment_history();
    },
  }
};
